<p class="q-card-secondary-text">
  <span class="q-card-secondary-text__icon">
    <ng-content select="[slot=icon]"></ng-content>
  </span>
  <span class="q-card-secondary-text__text">
    <ng-content select="[slot=text]"></ng-content>
  </span>
  <ng-content></ng-content>
</p>
